import React from 'react';

const FilterContext = React.createContext({
  selectedTopic: '',
  changeFilter: () => {},
  mediaTypes: [],
  selectedMediaType: '',
  go: () => {},
  themes: [],
  searchTopic: () => {},
  topics: [],
  selectedTopicSlug: '',
  isSearching: false,
  filteredTopicsList: [],
  clientDetails: {},
  isModal: false,
});

export default FilterContext;
